// Client lib imports
const airbrake = require('client/lib/airbrake')
const { FriendlyRequestError } = require('client/lib/request')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const { processImageFinalCrop } = require('client-v2/common/containers/upload-image-modal/utils')
// Cousin imports
const collectionEditModalActions = require('client-v2/collection-profile/containers/collection-edit-modal/actions')

// Action types

const SHOW = 'COLLECTION_EDIT_HEADER_IMAGE_MODAL_SHOW'
const HIDE = 'COLLECTION_EDIT_HEADER_IMAGE_MODAL_HIDE'

// Action creators

function show(payload) {
  return {
    type: SHOW,
    payload
  }
}

function hide() {
  return {
    type: HIDE
  }
}

function showPreviewError(err) {
  airbrake.notify(err)
  return confirmModalActions.alert({
    heading: 'Image processing failed',
    subheading: 'We could not use that image. Please try another.'
  })
}

// Action dispatchers

function deleteImage() {
  return async function (dispatch) {
    await dispatch(collectionEditModalActions.deleteHeaderImage())
    dispatch(hide())
  }
}

function submitImage({ image, crop }) {
  return async function (dispatch) {
    try {
      const file = await processImageFinalCrop(image, crop)
      await dispatch(collectionEditModalActions.uploadHeaderImage({ file }))
      dispatch(hide())
    } catch (err) {
      let message = 'We could not process this image.'
      if (err instanceof FriendlyRequestError) {
        message = err.message
      }
      dispatch(confirmModalActions.alert({
        heading: 'Failed to upload collection header image',
        subheading: message
      }))
      throw err
    }
  }
}

module.exports = {
  // Action types
  HIDE,
  SHOW,
  // Action creators
  hide,
  show,
  // Action dispatchers
  deleteImage,
  showPreviewError,
  submitImage
}
